import { render, staticRenderFns } from "./budgetStatus.vue?vue&type=template&id=355329fa&"
import script from "./budgetStatus.vue?vue&type=script&lang=js&"
export * from "./budgetStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports